import React, { Component } from "react";
import Footer from "../components/Footer/Footer";

class PageContainer extends Component<any, any> {

	public render() {
		return (
			<div id="page-container" className="page-header-dark main-content-boxed">
				{this.props.children}
				<Footer/>
			</div>
		);
	}
}

export default PageContainer;
